import { Rating as ReactRating } from '@smastrom/react-rating';

type RatingProps = {
    value: number;
};

export function Rating({ value }: RatingProps) {
    return (
        <div className='-ml-[3px] max-w-[120px]'>
            <ReactRating spaceBetween='small' value={value / 2} readOnly />
        </div>
    );
}
